import { render, staticRenderFns } from "./HelpCopySection.vue?vue&type=template&id=770830a9&scoped=true&"
import script from "./HelpCopySection.vue?vue&type=script&lang=js&"
export * from "./HelpCopySection.vue?vue&type=script&lang=js&"
import style0 from "./HelpCopySection.vue?vue&type=style&index=0&id=770830a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770830a9",
  null
  
)

export default component.exports